import React, {useState} from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {Autocomplete, TextField} from "@mui/material";
import {RENDERER_TYPES} from "../constants";

export const AutocompleteTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.autocomplete);

export const AutocompleteRenderer = withJsonFormsControlProps(
  ({data, handleChange, path, label, schema, required, errors}) => {
    const [value, setValue] = useState(data || []);

    const handleChangeKeywords = (_e, newValue) => {
      setValue(newValue);
      handleChange(path, newValue);
    };

    const options = schema?.elements || [];

    return (
      <Autocomplete
        multiple
        freeSolo={options.length === 0}
        options={options}
        value={value}
        onChange={handleChangeKeywords}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            label={label}
            required={required}
            error={!!errors}
            helperText={errors}
            className="custom-json-forms__renderers__autocomplete-field"
          />
        )}
        className="custom-json-forms__renderers__autocomplete"
      />
    );
  }
);
